import { useMemo } from "react";

import { NavLink } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import { SecondaryMenuStyles } from "../../themes";
import { type CategoryContext } from "../../types";

const useStyles = makeStyles((theme: Theme) => ({
  tab: {
    textTransform: "initial",
    minWidth: 0,
    padding: theme.spacing(0, 2.5),
  },
  root: {
    opacity: 1,
    color: theme.palette.text.primary,
  },
  indicator: {
    backgroundColor: theme.palette.navigation.accent,
    boxShadow: `inset 0px -2px 0px ${theme.palette.navigation.accent}`,
  },
}));

type Props = {
  isMobile: boolean;
  categoryContext?: CategoryContext;
};

const NavTabs = ({ isMobile, categoryContext }: Props) => {
  const classes = useStyles();

  const selectedTab = useMemo(() => {
    const selectedItem = categoryContext?.items.find((item) => item.isSelected);
    return selectedItem?.pageId;
  }, [categoryContext]);

  if (!selectedTab) {
    return null;
  }
  const tabsVariant = isMobile ? "scrollable" : "standard";

  return (
    <Box
      sx={[
        {
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          position: "relative",
          px: 2,
        },
        ...(Array.isArray(SecondaryMenuStyles) ? SecondaryMenuStyles : [SecondaryMenuStyles]),
      ]}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Tabs value={selectedTab} variant={tabsVariant} scrollButtons="auto">
          {categoryContext?.items?.map((item) => (
            <Tab
              className={classes.tab}
              classes={{ root: classes.root }}
              key={item.pageId}
              component={NavLink}
              label={
                item.icon ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {item.displayName}
                    <item.icon sx={{ fontSize: 18, ml: 0.5 }} />
                  </Box>
                ) : (
                  item.displayName
                )
              }
              value={item.pageId}
              to={item.fullRoute}
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  );
};

export default NavTabs;
